export default "__VITE_ASSET__4d8cb974__"